<template>
  <div v-if="result" class="other-card__container">
		<div class="other-card" :style="calculated_img(result,1)">
			<a :href="`${result['url']}`" @click="save_search">
				<div class="other-card__title">{{ result['title'] }}</div>
				<div class="btn btn-yellow btn-rounded">Page</div>
			</a>
		</div>
	</div>
</template>

<script>
export default {
  name: 'SiteSearchOtherCard',

  props: {
    result: {
      type: Object,
      default: {}
    }
  },

  data() {
    return {

    }
  },

	mounted() {
		//console.log('site search other', this.result);
	},

  methods: {
    calculated_img(item,index) {
			if (item.image !== "") {
				return 'background-image: url('+this.$filters.analyseImage(item.image,'herosearchxs','herosearchsm')+');';
			}
			return 'background-image: url(/images/collections/collection-bg-'+(index+1)+'.jpg);';
		},
		save_search() {
			this.$emit('save:search');
		}
  },

  computed: {

  }
}
</script>
